export default function () {
  function noScroll(event) {
    event.preventDefault();
  }

  $('.js-modal-cont').on('click', function(e) {
    e.stopPropagation();
  });

  $('.js-modal-trigger').on('click', function(e) {
    e.preventDefault();
    let $target = $($(this).attr('href'));
    $target.show();
    // $('body').addClass('c-show-modal-2');
    setTimeout(function() {
      $target.addClass('is-active');
    },20);

    document.addEventListener('wheel', noScroll, { passive: false });
    document.addEventListener('mousewheel', noScroll, { passive: false });
  });

  $('.js-modal-close, .js-modal-unit').on('click', function(e) {
    e.preventDefault();
    $('.js-modal-unit').removeClass('is-active');
    $('.js-modal-unit').css({'height': '100vh', 'overflow': 'hidden'});
    // $('body').removeClass('c-show-modal-2');
    setTimeout(function() {
      $('.js-modal-unit').hide();
      $('.js-modal-unit').removeAttr('style');
    },450);
    document.removeEventListener('wheel', noScroll, { passive: false });
    document.removeEventListener('mousewheel', noScroll, { passive: false });
  });

}
